import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './main.less';

import range from 'lodash/range';
import isNull from 'lodash/isNull';

const NEIGHBOR_COUNT = 3;

function Pagination({ className, currentPage, total, perPage, gotoPage }) {
	const pages = range(1, Math.ceil(total / perPage) + 1);

	const paginationPages = [];

	pages.forEach((page) => {
		if (page === 1 || page === pages.length || Math.abs(page - currentPage) <= NEIGHBOR_COUNT) {
			paginationPages.push({
				number: page,
				active: page === currentPage
			});
		} else if (!isNull(paginationPages[paginationPages.length - 1].number)) {
			paginationPages.push({
				number: null,
				active: false
			});
		}
	});

	return (
		<div className={cn('new-pagination', className)}>
			<div className="new-pagination__total">
				Total: {total}
			</div>
			{paginationPages.map((page, i) => (
				<a
					className={cn('new-pagination__item', {
						active: page.active
					})}
					onClick={() => {
						page.number && gotoPage(page.number);
					}}
					key={i}
				>
					{page.number ? page.number : '...'}
				</a>
			))}
		</div>
	);
}

Pagination.propTypes = {
	className: PropTypes.string,
	currentPage: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	perPage: PropTypes.number.isRequired,
	gotoPage: PropTypes.func.isRequired
};

export default Pagination;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-pagination/main.js